<template>
  <div>
    <div class="weui-mask" id="iosMask" style="display: none;"></div>
    <div class="weui-actionsheet" id="iosActionsheet">
      <!--
        <div class="weui-actionsheet__title">
            <p class="weui-actionsheet__title-text">{{title}}</p>
        </div>
      -->
      <div class="weui-actionsheet__menu menuContainer" >
        <div class="weui-actionsheet__cell" :key="itm.key" v-for="itm in itms" @click="toDir(itm.url)">
          {{ itm.caption }}
        </div>
      </div>
      <!--
      <div class="weui-actionsheet__action">
          <div class="weui-actionsheet__cell" id="iosActionsheetCancel">关闭</div>
      </div>
    -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  data() {
    return {
      itms: [{'url': '/', 'caption': '首页'}
      ],
    }
  },
  methods: {
    toDir(url) {
      var $iosActionsheet = $('#iosActionsheet');
      var $iosMask = $('#iosMask');
      this.$router.push(url)
      $iosActionsheet.removeClass('weui-actionsheet_toggle up80px');
      $iosMask.fadeOut(200);
    },
    initMenu(data) {
      console.log('页面数据', data);
      if (data) this.itms = data;
      var $iosActionsheet = $('#iosActionsheet');
      var $iosMask = $('#iosMask');

      function hideActionSheet() {
        $iosActionsheet.removeClass('weui-actionsheet_toggle up80px');
        $iosMask.fadeOut(200);
      }

      console.log("initMenu")

      $iosMask.on('click', hideActionSheet);
      $('#iosActionsheetCancel').on('click', hideActionSheet);

      $iosActionsheet.addClass('weui-actionsheet_toggle up80px');
      $iosMask.fadeIn(200);
    },

  }

}
</script>

<style>
.up80px {
  bottom: 80px;
}
.menuContainer{
  max-height: calc(100vh - 125px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/menuSecond.vue